import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, saveCard } from '../../../constants/globalConstants'
import { getPermitDataList, getPermitQR, PermitRenewData } from '../../../redux/actions/PermitListAction'
import { Circles } from 'react-loader-spinner'
import { renderNoResults } from '../../../components/global/NoDataFound'
// import { staticStrings } from '../../../constants/staticStrings'
import { errorMessage } from '../../../constants/errorMessage'
import moment from 'moment'
import { perkingParkingTime, isPermissionExist, sortPortalPermissionByKey, encryptionHandler, isLoggedIn, validExpiryDate } from '../../../utils/helper'
import { CancelPermit } from '../../../redux/actions/PermitRequestAction'
import AddCardPaymentModal from '../../../components/global/addCardPaymentModal'
import { getCardDataList } from '../../../redux/actions/cardDetailsAction'
import PassWalletButtons from '../../../components/global/PassWalletButtons'
import { APICONFIG } from '../../../redux/config/apiConfig'
// import { errorMessages } from '../../../constants/errorMessages'
// import { Link } from 'react-router-dom'

// let moment = require('moment')

function PermitAccount(props) {
    const { dispatch, loader, notify, partnerDetails, setPermitCount } = props
    const [permitListData, setPermitListData] = useState(EMPTY_ARRAY)
    // const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [displayVehicle, setDisplayVehicle] = useState(false)
    const [downloadQR, setDownloadQR] = useState(false)
    const [displayError, setDisplayError] = useState('')
    const [accessPermissions, setAccessPermissions] = useState('')
    const [permit_no, setPermitNo] = useState(EMPTY_OBJECT)
    const [isModalOpen, setModal] = useState(false)
    const [ispermitLoad, setIspermitLoad] = useState(true)
    const [cardExpiryMessage, setCardExpiryMessage] = useState('')

    //new

    const [expiry, setExpiry] = useState()

    const [card, setCard] = useState()

    const [payload, setPayload] = useState(saveCard)

    const [isLoading, setIsLoading] = useState(false)

    const [errorMessagePay, setErrorMessagePay] = useState('')

    const [cardList, setCardList] = useState(EMPTY_ARRAY)

    const [isCardFormVisible, setCardFormVisible] = useState(false)

    const [error, setError] = useState(false)

    const [isConsent, setIsConsent] = useState(true)

    let dateDisplayFormat = 'DD MMM, YYYY'

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])


    useEffect(() => {

        // setTimeout(
        dispatch(getPermitDataList()).then((res) => {

            if (res?.data && res?.data != null) {
                // const userData = localStorage.getItem('userData')
                // const userDetails = JSON.parse(userData)
                // setUserData(userDetails)
                setPermitListData(res?.data)
                setPermitCount(res?.data)
                setIsConsent(res?.data?.user_consent == '1' ? true : false)
                setIspermitLoad(false)
            } else {
                setIspermitLoad(false)
                setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch((err) => {
            setIspermitLoad(false)
            setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })

        //     if (res) {
        //         // const userData = localStorage.getItem('userData')
        //         // const userDetails = JSON.parse(userData)
        //         // setUserData(userDetails)
        //         setPermitListData(res)
        //     }
        // })
        // , 500)

        if (isLoggedIn()) {
            setCardFormVisible(false)
            const facility_id = partnerDetails?.facilities?.[0]?.id
            dispatch(getCardDataList(facility_id)).then((res) => {
                if (res?.data) {
                    setCardList(res?.data?.payments)
                    // setIsLoading(false)
                }
            }).catch(() => {
                // setIsLoading(false)
            })
        } else {
            setCardFormVisible(true)
        }

    }, [EMPTY_ARRAY])

    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }

    const handlePaymentModalOpen = (item) => {
        setPermitNo(item)
        setModal(true)
    }

    const handleCardSelectChange = (e) => {

        const { value } = e.target

        const selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)

        payload['payment_profile_id'] = selectedCard[0]?.payment_profile_id

        setPayload({ ...payload })

    }

    const handleExpiryChange = (value) => {

        let expiryDateCheck = validExpiryDate(value)
        if (value.length == 4 && !expiryDateCheck) {
            setCardExpiryMessage('Enter a valid expire date')
        } else {
            setCardExpiryMessage('')
            setExpiry(value?.trim())
            payload['expiration_date'] = value?.trim()
            setPayload({ ...payload })
        }

    }



    // const handleExpiryChange = (value) => {

    //     setExpiry(value?.trim())

    //     payload['expiration_date'] = value?.trim()

    //     setPayload({ ...payload })

    // }



    const handleCardChange = (value) => {

        setCard(value?.trim())

        payload['card_number'] = value?.trim()

        setPayload({ ...payload })

    }

    const hanndleCancel = () => {
        setPayload({ card_number: '', expiration_date: '', payment_profile_id: '' })
        setCard('')
        setExpiry('')
        setModal(false)
    }

    const handleInputFieldsData = (e) => {


        const { name, value } = e.target
        // console.log('handleInputFieldsData',name,value)

        setPayload({ ...payload, [name]: value })

    }




    const handleSubmit = () => {
        // console.log('payload',payload)

        setError(true)

        setIsLoading(true)

        if (Object.values(payload)?.length > 0 && payload?.payment_profile_id || (payload?.card_number && payload?.card_number?.length === 16 && payload?.expiration_date && payload?.security_code)) {

            payload.zip_code = payload?.zip_code_on_card || ''

            let finalPayload

            setErrorMessagePay('')

            if (!payload?.payment_profile_id || payload?.payment_profile_id == '') {

                finalPayload = {

                    'nonce': encryptionHandler(payload),

                    'permit_number': permit_no?.account_number,

                    'user_consent': 1,

                    'payable_permit_amount': payload?.payable_permit_amount ? payload?.payable_permit_amount : '',

                }

            } else {

                finalPayload = {

                    'payment_profile_id': payload?.payment_profile_id,

                    'permit_number': permit_no?.account_number,

                    'user_consent': 0,

                    'payable_permit_amount': payload?.payable_permit_amount ? payload?.payable_permit_amount : '',

                }

            }

            dispatch(PermitRenewData(finalPayload)).then((res) => {

                if (res && res?.data !== null) {

                    notify('success', 'Payment is made successfully')

                    setPayload({ card_number: '', expiration_date: '', payment_profile_id: '' })

                    setCard('')

                    setExpiry('')

                    setModal(false)

                    setError(false)

                    setIsLoading(false)

                    dispatch(getPermitDataList()).then((res) => {

                        if (res?.data && res?.data != null) {

                            // const userData = localStorage.getItem('userData')

                            // const userDetails = JSON.parse(userData)

                            // setUserData(userDetails)

                            setPermitListData(res?.data)

                        } else {

                            setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)

                        }

                    }).catch((err) => {

                        setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)

                    })

                } else if (res?.data === null && res?.errors?.message) {

                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')

                    setIsLoading(false)

                }

            }).catch((err) => {

                // setErrorMessage(err?.errors?.message)

                notify('error', err?.errors?.message ? err?.errors?.message : 'Something went wrong, Please try again!')
                console.log('loader', loader)
            })

        } else {

            setIsLoading(false)

            setErrorMessagePay('')

        }

    }

    const downloadPermitQr = (id, permitAccount) => {
        setDownloadQR(true)
        if (!downloadQR) {
            dispatch(getPermitQR(id, permitAccount)).then((res) => {
                setDownloadQR(false)
                if (res?.status && res?.status == 500) {
                    notify('error', errorMessage?.somethingWentWrong)
                } else {
                    notify('success', 'File Downloaded')
                }
            }).catch((err) => {
                setDownloadQR(false)
                notify('error', err ? err?.message ? err?.message : errorMessage?.somethingWentWrong : errorMessage?.somethingWentWrong)
            })
        }

    }


    const cancelPermit = (data, index) => {
        // setPermitListData
        let resp = (permitListData[index].user_consent === '1') ? '0' : '1'
        permitListData[index].user_consent = resp
        setPermitListData(permitListData)
        setIsConsent(!isConsent)
        dispatch(CancelPermit(data.id)).then((res) => {
            notify('success', res.msg)
            // dispatch(getPermitDataList()).then((res) => {
            //     if (res?.data && res?.data != null) {
            //         // const userData = localStorage.getItem('userData')
            //         // const userDetails = JSON.parse(userData)
            //         // setUserData(userDetails)
            //         setPermitListData(res?.data)
            //     } else {
            //         setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            //     }
            // }).catch((err) => {
            //     setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            // })
        }).catch((err) => {
            console.log(err)
        })

    }




    return (
        ispermitLoad ? <span className='ms-2 d-flex justify-content-center'><Circles
            height="50"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></span> :
            <div>
                <div className="d-flex justify-content-between mb-4">
                    <h4 className="fw-bold">Permit Account </h4>
                    {/* <Link to='/'>
                    <button className="btn btn-success ms-auto"><i className="fa fa-plus"></i> Add</button>
                </Link> */}
                </div>
                {permitListData?.length > 0 ? <ul className="permitList">
                    {permitListData?.map((item, index) => {
                        if (item == null) return null
                        // const is_active = moment(item?.desired_end_date).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
                        return (

                            <li className={`TicketCardStyle mb-5 ${item?.is_expired == 0 && item?.cancelled_at == null ? 'active border-success' : 'inactive border-danger'}`} key={index}>
                                {/* title box started here */}
                                <div className='d-flex justify-content-sm-between mb-4 gap-2 align-items-sm-center flex-column flex-sm-row'>
                                    <div id='titles' className='d-flex gap-2  '>
                                        <i className={`fa fa-parking fa-2x   ${item?.is_expired == 0 && item?.cancelled_at == null ? 'text-success ' : 'text-danger '}`}></i>
                                        <div  >
                                            <h4 style={{ lineHeight: '0.7' }} className={`mb-0 fw-bold d-block  lh-0  ${item?.is_expired == 0 && item?.cancelled_at == null ? 'text-success ' : 'text-danger '} `}>   Permit No #{item?.account_number} </h4>
                                            <small>{item?.permit_rate?.name} Plan</small>
                                        </div>
                                        {/* <small className={item?.is_expired == 0 && item?.cancelled_at == null ? 'text-success' : 'text-white'}><i className='fa fa-circle '></i> {item?.is_expired == 0 && item?.cancelled_at == null ? 'Active' : item?.cancelled_at == null ? 'In-active' : 'Canceled'}</small> */}
                                    </div>
                                    <div id='actionButtons'>
                                        {((item?.is_expired == 0 && item?.cancelled_at == null) || (item?.user_consent === '1')) && <div className='d-flex gap-3'>
                                            {(item?.is_expired == 0 && item?.cancelled_at == null) ? <button
                                                className='btn p-0 text-primary'
                                                type='button'
                                                disabled={downloadQR}
                                                onClick={() => downloadPermitQr(item?.id, item?.account_number)}>
                                                <i className='fa fa-qrcode'></i>  Download QR
                                            </button>
                                                : ''}
                                            {/* {item?.user_consent === '1' && <span className='border border-e'></span>} */}



                                            <div className='form-check  form-switch'>
                                                <input type="checkbox" id='cancelAutoRenewToggle' checked={item?.user_consent == '1' ? true : false} onClick={() => cancelPermit(item, index)} className='form-check-input' />
                                                <label htmlFor='cancelAutoRenewToggle' className='form-check-label small fw-normal text-danger'>Cancel Auto Renew </label></div>

                                        </div>}
                                    </div>
                                </div>
                                {/*  title box ends */}

                                {/*  devider line */}

                                <div className='border border-dashed my-4 d-block w-100'></div>

                                {/*  divider line ends */}
                                <div className='row justify-content-between g-3 mb-3 '>
                                    <div className=' col-md-4 lh-08 '>
                                        <div className="d-flex align-items-lg-center gap-2">
                                            <i className=' fa fa-parking fa-2x'></i>
                                            <div>
                                                <h4 className='mb-0 fw-bold '>{item?.facility?.full_name} </h4>
                                                <small className='text-muted '>{item?.permit_type_name}</small>
                                            </div>
                                        </div>

                                    </div>
                                    <div className=' col-md-4'>
                                        <div className='dateRangeSelector'>
                                            <div className='d-flex w-full'>
                                                <div className='leftBlock w-full justify-content-start gap-2 p-2 d-flex align-items-center'>
                                                    <i className='fa fa-calendar text-success '></i>
                                                    <div  >
                                                        <small>Start at</small>
                                                        <h5 className='fw-bold m-0' >{moment(item?.desired_start_date).format('MM/DD/YYYY')}</h5>
                                                    </div>

                                                </div>
                                                <div className='rightBlock w-full border-start p-2 justify-content-end text-end gap-2 d-flex align-items-center'>

                                                    <div >
                                                        <small>End at</small>
                                                        <h5 className='fw-bold m-0' >{moment(item?.desired_end_date).format('MM/DD/YYYY')}</h5>
                                                    </div>
                                                    <i className='fa fa-calendar text-danger '></i>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className=' col-md-4 text-sm-end lh-08'>
                                        {item?.permit_rate ? perkingParkingTime(item?.permit_rate, true) : null}

                                    </div>
                                </div>


                                {/*  second row */}
                                {/* uploaded documents */}
                                <div className='bg-light horizontal-gradient my-3 p-3 rounded-4'>
                                    <div className='d-flex align-items-sm-center gap-sm-5 gap-2 flex-column  flex-sm-row'>
                                        <h5 className='fw-bold m-0 ' > <i className='fa fa-file me-2'></i>  Uploaded Document - </h5>

                                        {item?.permit_doc?.length > 0 ?
                                            item?.permit_doc?.map((item, index) => {
                                                return (

                                                    <a key={index} href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='text-primary text-start btn p-0 '> <span className="text-dark">{item?.doc_name}</span> <i className='fa fa-eye'></i></a>

                                                )
                                            })
                                            : <div className='col'>
                                                <span className='fontsize85'>
                                                    N/A
                                                </span>
                                            </div>}
                                    </div>
                                </div>

                                {/* vehicle table section */}
                                {/* 
                                {item?.permit_vehicle && <div className='my-3'>
                                    <div className="d-flex align-items-center mb-2 w-full justify-content-between">
                                        <b>Vehicles</b>                                             {item?.permit_vehicle?.length > 1 ? <button className='btn btn-light btn-sm' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</button> : null}
                                    </div>
                                    <div className='table-responsive'>
                                        <table style={{ minWidth: '400px' }} className='table table-sm table-borderless' >
                                            <thead scope="row" >
                                                {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <th scope='col' className='small text-muted fw-normal '>License Plate</th>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.color && <th scope='col' className='small text-muted fw-normal ' >Color</th>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.make && <th scope='col' className='small text-muted fw-normal '>Make</th>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.model && <th scope='col' className='small text-muted fw-normal ' >Model</th>
                                                }
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <td className='p-0 lh-4'  ><img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png" />  {item?.permit_vehicle[0]?.vehicle?.license_plate_number}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.color && <td className='p-0 lh-4'  > <i className='fa small opacity-25 fa-palette'></i> {item?.permit_vehicle[0]?.vehicle?.color}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.make && <td className='p-0 lh-4'   > <i className='fa small opacity-25 fa-car'></i> {item?.permit_vehicle[0]?.vehicle?.make}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.model && <td className='p-0 lh-4'  > <i className='fa small opacity-25 fa-car-side'></i>  {item?.permit_vehicle[0]?.vehicle?.model}</td>
                                                    }
                                                </tr>


                                                {displayVehicle && item?.permit_vehicle && <>
                                                    {item?.permit_vehicle?.length > 0 && item?.permit_vehicle?.map((item, index) => {
                                                        return <tr key={index}>
                                                            <td className='p-0 lh-4' ><img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png" /> {item?.vehicle?.license_plate_number ? item?.vehicle?.license_plate_number : '-'}</td>
                                                            <td className='p-0 lh-4' ><i className='fa small fa-palette opacity-25'></i> {item?.vehicle?.color ? item?.vehicle?.color : '-'}</td>
                                                            <td className='p-0 lh-4' ><i className='fa small fa-car opacity-25'></i> {item?.vehicle?.make ? item?.vehicle?.make : '-'}</td>
                                                            <td className='p-0 lh-4' ><i className='fa small fa-car-side opacity-25'></i> {item?.vehicle?.model ? item?.vehicle?.model : '-'}</td>
                                                        </tr>
                                                    })}



                                                </>}

                                            </tbody>
                                        </table></div>

                                </div>
                                } */}
                                {/* // new design for vehicle table */}
                                {item?.permit_vehicle && item?.permit_vehicle?.length > 0 && <div className='my-3'>
                                    <div className="border border-dashed my-4 d-block w-100"></div>
                                    <div className="d-flex align-items-center mb-2 w-full justify-content-between">
                                        <b>Vehicle(s)</b>{item?.permit_vehicle?.length > 1 ? <button className='btn btn-outline-dark btn-sm btn-sm' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</button> : null}
                                    </div>

                                    <div className='table-responsive'>
                                        {/* Header Row - Desktop */}
                                        <table style={{ minWidth: '400px' }} className='table table-sm table-borderless' >
                                            <thead scope="row" >
                                                <th scope='col' className='small text-muted fw-normal'>License Plate</th>
                                                <th scope='col' className='small text-muted fw-normal'>Make</th>
                                                {item?.permit_vehicle[0]?.vehicle?.model && <th scope='col' className='small text-muted fw-normal'>Model</th>}
                                                {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <th scope='col' className='small text-muted fw-normal'>Vehicle Type</th> : null}
                                                <th scope='col' className='small text-muted fw-normal'>Color</th>
                                                {isPermissionExist(accessPermissions, 'Get Vehicle Style') && <th scope='col' className='small text-muted fw-normal'>Style</th>}
                                                {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && <th scope='col' className='small text-muted fw-normal'>Country</th>}
                                                <th scope='col' className='small text-muted fw-normal'>State</th>
                                                {isPermissionExist(accessPermissions, 'Vin Number') && <th scope='col' className='small text-muted fw-normal'>VIN</th>}
                                                {isPermissionExist(accessPermissions, 'Year') && <th scope='col' className='small text-muted fw-normal'>Year</th>}
                                            </thead>


                                            {/* Single Vehicle Display */}
                                            <tbody>
                                                {!displayVehicle && (
                                                    <tr>
                                                        <td className='p-0 lh-4'>
                                                            {item?.permit_vehicle[0]?.vehicle?.license_plate_number ? <><img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png" /> {item?.permit_vehicle[0]?.vehicle?.license_plate_number}</> : <span className="text-muted">-</span>}
                                                        </td>
                                                        <td className="p-0 lh-4" data-label="Make">
                                                            {item?.permit_vehicle[0]?.vehicle?.make ? <><i className='fa small opacity-25 fa-car'></i> {item?.permit_vehicle[0]?.vehicle?.make}</> : <span className="text-muted">-</span>}
                                                        </td>
                                                        <td className="p-0 lh-4" data-label="Model">
                                                            {item?.permit_vehicle[0]?.vehicle?.model ? <><i className='fa small opacity-25 fa-car-side'></i> {item?.permit_vehicle[0]?.vehicle?.model}</> : <span className="text-muted">-</span>}
                                                        </td>
                                                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') && (
                                                            <td className="p-0 lh-4" data-label="Vehicle Type">
                                                                {item?.permit_vehicle[0]?.vehicle?.vehicle_type || <span className="text-muted">-</span>}
                                                            </td>
                                                        )}
                                                        <td className="p-0 lh-4" data-label="Color">
                                                            {item?.permit_vehicle[0]?.vehicle?.color ? <><i className='fa small opacity-25 fa-palette'></i> {item?.permit_vehicle[0]?.vehicle?.color}</> : <span className="text-muted">-</span>}
                                                        </td>
                                                        {(item?.permit_vehicle[0]?.vehicle?.style && isPermissionExist(accessPermissions, 'Get Vehicle Style')) && (
                                                            <td className="p-0 lh-4" data-label="Style">
                                                                {item?.permit_vehicle[0]?.vehicle?.style}
                                                            </td>
                                                        )}
                                                        {(item?.permit_vehicle[0]?.vehicle?.country && isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode')) && (
                                                            <td className="p-0 lh-4" data-label="Country">
                                                                {item?.permit_vehicle[0]?.vehicle?.country}
                                                            </td>
                                                        )}
                                                        <td className="p-0 lh-4" data-label="State">
                                                            {item?.permit_vehicle[0]?.vehicle?.state_code || <span className="text-muted">-</span>}
                                                        </td>
                                                        {(item?.permit_vehicle[0]?.vehicle?.vehicle_number && isPermissionExist(accessPermissions, 'Vin Number')) && (
                                                            <td className="p-0 lh-4" data-label="VIN">
                                                                {item?.permit_vehicle[0]?.vehicle?.vehicle_number}
                                                            </td>
                                                        )}
                                                        {isPermissionExist(accessPermissions, 'Year') && <td className="p-0 lh-4" data-label="Year">
                                                            {item?.permit_vehicle[0]?.vehicle?.year || <span className="text-muted">-</span>}
                                                        </td>}
                                                    </tr>
                                                )}


                                                {/* Multiple Vehicles Display */}
                                                {displayVehicle && item?.permit_vehicle && item?.permit_vehicle?.map((vehicleItem, index) => (
                                                    <tr className="vehicle-grid-row" key={index}>
                                                        <td className="p-0 lh-4" data-label="License Plate">
                                                            <img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png" />
                                                            {vehicleItem?.vehicle?.license_plate_number || <span className="text-muted">-</span>}
                                                        </td>
                                                        <td className="p-0 lh-4" data-label="Make">
                                                            {vehicleItem?.vehicle?.make && <i className='fa small fa-car opacity-25'></i>}
                                                            {vehicleItem?.vehicle?.make || <span className="text-muted">-</span>}
                                                        </td>
                                                        {vehicleItem?.vehicle?.model && (
                                                            <td className="p-0 lh-4" data-label="Model">
                                                                {vehicleItem?.vehicle?.model && <i className='fa small fa-car-side opacity-25'></i>}
                                                                {vehicleItem?.vehicle?.model || <span className="text-muted">-</span>}
                                                            </td>
                                                        )}
                                                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') && (
                                                            <td className="p-0 lh-4" data-label="Vehicle Type">
                                                                {vehicleItem?.vehicle?.vehicle_type || <span className="text-muted">-</span>}
                                                            </td>
                                                        )}
                                                        <td className="p-0 lh-4" data-label="Color">
                                                            {vehicleItem?.vehicle?.color && <i className='fa small fa-palette opacity-25'></i>}
                                                            {vehicleItem?.vehicle?.color || <span className="text-muted">-</span>}
                                                        </td>
                                                        {isPermissionExist(accessPermissions, 'Get Vehicle Style') && (
                                                            <td className="p-0 lh-4" data-label="Style">
                                                                {vehicleItem?.vehicle?.style || <span className="text-muted">-</span>}
                                                            </td>
                                                        )}
                                                        {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && (
                                                            <td className="p-0 lh-4" data-label="Country">
                                                                {vehicleItem?.vehicle?.country || <span className="text-muted">-</span>}
                                                            </td>
                                                        )}
                                                        <td className="p-0 lh-4" data-label="State">
                                                            {vehicleItem?.vehicle?.state_code || <span className="text-muted">-</span>}
                                                        </td>
                                                        {isPermissionExist(accessPermissions, 'Vin Number') && (
                                                            <td className="p-0 lh-4" data-label="VIN">
                                                                {vehicleItem?.vehicle?.vehicle_number || <span className="text-muted">-</span>}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>}



                                <div className='row d-none'>

                                    <div className='col-sm mb-sm-0 mb-3'>

                                        <table cellSpacing="0px" cellPadding="0">
                                            <tr>
                                                <th className='text-muted d-none'>Driver License No.:</th><td className='px-2'></td> <td className='text-end'>{item?.license_number}</td>
                                            </tr>
                                            {item?.user?.resident_status ? <tr>
                                                <th colSpan="3" className='text-muted d-none'><span className="badge bg-success"> {item?.user?.resident_status}</span></th>
                                            </tr> : <span className='text-muted d-none'>NA</span>}
                                        </table>
                                        {/* <p className='text-muted mb-0  '>{item?.user?.license_number}<br/>  <b>Driving License No.</b></p> */}
                                    </div>
                                    {item?.permit_vehicle && <div className='col-12 col-sm-12 order-sm-1 order-4 mt-sm-0'>
                                        <table className='table border  mt-3' >
                                            <thead className='border-bottom bg-light' >
                                                {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <th className='p-2 border-e' >License Plate:</th>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.color && <th className='p-2 border-e' >Color:</th>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.make && <th className='p-2 border-e' >Make:</th>
                                                }
                                                {item?.permit_vehicle[0]?.vehicle?.model && <th className='p-2 ' >Model:</th>
                                                }
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <td className='p-2 border-e' >{item?.permit_vehicle[0]?.vehicle?.license_plate_number}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.color && <td className='p-2 border-e' >{item?.permit_vehicle[0]?.vehicle?.color}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.make && <td className='p-2 border-e' >{item?.permit_vehicle[0]?.vehicle?.make}</td>
                                                    }
                                                    {item?.permit_vehicle[0]?.vehicle?.model && <td className='p-2 ' >{item?.permit_vehicle[0]?.vehicle?.model}</td>
                                                    }
                                                </tr>
                                            </tbody>
                                        </table>
                                        {item?.permit_vehicle?.length > 1 ? <span className='fw-bold text-primary text-decoration-underline cursor' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</span> : null}

                                    </div>
                                    }

                                </div>

                                {/* 
                                    {displayVehicle && <span><hr />
                                        <b className='text-muted fw-bold'>Vehicles:</b>
                                        <div className='row align-items-center justify-content-between  '>
                                            <div className='col-sm-12 '>
                                                {item?.permit_vehicle && <div className='col-12 col-sm-auto order-sm-1 order-4 mt-sm-0  '>
                                                    <table cellSpacing="0px" cellPadding="0" className='table'>
                                                        <thead>
                                                            <tr>
                                                                <th className='text-muted'>License Plate</th>
                                                                <th className='text-muted'>Color</th>
                                                                <th className='text-muted'>Make</th>
                                                                <th className='text-muted'>Model</th>
                                                            </tr>
                                                        </thead>
                                                        {item?.permit_vehicle?.length > 0 && item?.permit_vehicle?.map((item, index) => {
                                                            return <tr key={index}>
                                                                <td className='text-start ps-2'>{item?.vehicle?.license_plate_number ? item?.vehicle?.license_plate_number : '-'}</td>
                                                                <td className='text-start ps-2'>{item?.vehicle?.color ? item?.vehicle?.color : '-'}</td>
                                                                <td className='text-start ps-2'>{item?.vehicle?.make ? item?.vehicle?.make : '-'}</td>
                                                                <td className='text-start ps-2'>{item?.vehicle?.model ? item?.vehicle?.model : '-'}</td>
                                                            </tr>
                                                        })}
                                                    </table>

                                                </div>
                                                }
                                            </div>
                                        </div></span>} */}


                                {/*  transtion card detils */}
                                <div className='border border-dashed my-4 d-block w-100'></div>
                                {item?.transaction?.anet_trans_id ? <div className='row g-5 row-cols-1 row-cols-sm-auto ' >
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Amount paid  </small>
                                        <p className='m-0'> ${item?.permit_final_amount}</p>
                                    </div>
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Transaction Number  </small>
                                        <p className='m-0'>#{item?.transaction?.anet_trans_id ? item?.transaction?.anet_trans_id : '-'}</p>
                                    </div>
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Card details </small>
                                        <p className='m-0'>Ending With -
                                            {/* <i className="fa-brands fa-cc-visa"></i> */}
                                            {item?.paymentDetails?.card_last_four} | Exp - {item?.paymentDetails?.expiry ? item?.paymentDetails?.expiry?.slice(0, 2) + '/' + item?.paymentDetails?.expiry?.slice(2, 4) : '-'}</p>
                                    </div>
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Payment Date  </small>
                                        <p className='m-0'><i className='fa fa-clock'></i> {moment(item?.transaction?.created_at).format('MM/DD/YYYY hh:mm a')}</p>
                                    </div>




                                </div> : null}
                                <div className='mt-3'>
                                    <PassWalletButtons
                                        ticketId={item?.account_number}
                                        googleWalletApi={APICONFIG.getGooglePermitPassDownload}
                                        appleWalletApi={APICONFIG.getapplePermitPassDownload}
                                        notify={notify}
                                        partnerDetails={partnerDetails}
                                    />
                                </div>
                                {/*  card details ends */}


                                <div className='border border-dashed my-4 d-block w-100'></div>

                                {(isPermissionExist(accessPermissions, 'Display Permit Pay Now') && item?.permit_renew_pay == '1' && Number(item?.total_permit_amount) > 0 && item?.cancelled_at == null) ? <div className='row g-sm-5 g-2   align-items-end justicy-content-between'>


                                    <div className='col-auto flex-grow-1 '>
                                        <span className='text-muted small d-block lh-0 '>Bill Cycle</span>
                                        <b >{item?.billing_start_date ? moment(item?.billing_start_date).format(dateDisplayFormat) : ''} - {item?.billing_end_date ? moment(item?.billing_end_date).format(dateDisplayFormat) : ''}</b>
                                    </div>

                                    <div className='col-auto pr-md-4 border-sm-end   '>

                                        <b className='fw-bold small  lh-0 '>Amount Due</b>
                                        <h2 className='m-0 lh-5 fw-bold' >
                                            ${item?.total_permit_amount}
                                        </h2>





                                    </div>



                                    <div className='col-auto'><button className="btn btn-success btn-lg" onClick={() => handlePaymentModalOpen(item)}>Pay Now</button>  </div>

                                </div> : ''}



                                <div className='card-footer p-3 d-none'>
                                    <div className='row align-items-center justify-content-between  '>
                                        <div className='col-sm-4 text-end order-sm-1 order-4 '>
                                            {item?.transaction?.total && <p className='mb-0'><b className=' fw-bold'>Paid: </b> ${item?.transaction?.total}</p>}
                                        </div>
                                        {/* production script */}
                                        {/* {item?.permit_renew_pay == '1' && item?.renewal_due_amount > 0  ?  <div className='col-sm-4 '>
                                        <small><b className='fw-bold'>Amount Due:</b>  <br className='d-block d-sm-none' />{item?.renewal_due_amount}</small>
                                        </div>:''} */}
                                        {/*  local script */}
                                        <div className='col-sm-4 '>
                                            <small><b className='fw-bold'>Amount Due:</b>  <br className='d-block d-sm-none' />${item?.transaction?.total}</small>
                                        </div>

                                        {/* <div className='col-sm-4 '> */}
                                        {/* <small><b className='text-muted fw-bold'>Valid Till:</b>  <br className='d-block d-sm-none' />{item?.formatted_desired_end_date}</small> */}
                                        {/* <small><b className='text-muted fw-bold'>Disclaimer:</b>  <br className='d-block d-sm-none' />{staticStrings?.rates24}</small> */}
                                        {/* </div> */}
                                        <div className='col-sm-4 '>
                                            <small><b className='t fw-bold'>Autopay Enabled</b> - <br className='d-block d-sm-none' />{item?.user_consent ? item?.user_consent == '1' ? 'Yes' : 'No' : 'Yes'}</small>
                                        </div>
                                    </div>

                                    {((item?.is_expired == 0 && item?.cancelled_at == null) || (item?.user_consent === '1')) && <div className='d-flex justify-content-between'>
                                        {(item?.is_expired == 0 && item?.cancelled_at == null) ? <span>
                                            <button
                                                className='mt-3 btn btn-primary btn-sm'
                                                type='button'
                                                disabled={downloadQR}
                                                onClick={() => downloadPermitQr(item?.id, item?.account_number)}>
                                                Download QR
                                            </button>
                                        </span> : <span></span>}
                                        {/* {item?.user_consent === '1' && <>
                                            <button className='mt-3 btn btn-danger btn-sm' onClick={() => cancelPermit(item)}>Cancel Auto Renew 2</button>
                                        </>} */}
                                        {/* <div className="w-auto">
       
                                        <div className="form-check form-switch">
  <input className="form-check-input" type="checkbox" role="switch" id='autopayconsent' name='autopayconsent' checked={isConsent} onChange={() => cancelPermit(item)} />
  <label className="form-check-label" htmlFor="autopayconsent">AutoPay Consent</label>
</div>
                                <i className='d-block small'>By clicking this button, you are providing<br/> your consent for auto renewal.</i>

                            </div> */}

                                    </div>}
                                    {/* <div>
                                        <small className='text-danger'>{userData?.user?.license_number != item?.license_number ? errorMessages?.licenseAlertMessage : ''}</small>
                                    </div> */}
                                </div>





                            </li>
                        )
                    })}
                </ul> : renderNoResults(displayError)}
                <AddCardPaymentModal isModalOpen={isModalOpen} hanndleCancel={hanndleCancel} cardList={cardList} setPayload={setPayload} setCardList={setCardList} setCardFormVisible={setCardFormVisible} isCardFormVisible={isCardFormVisible} setModal={setModal} handleSubmit={handleSubmit} payload={payload} modalName='Add Payment' isLoading={isLoading} handleCardChange={handleCardChange} handleExpiryChange={handleExpiryChange} handleCardSelectChange={handleCardSelectChange} expiry={expiry} cardExpiryMessage={cardExpiryMessage} card={card} errorMessage={errorMessagePay} error={error} setErrorMessage={setErrorMessagePay} setError={setError} setCard={setCard} setExpiry={setExpiry} handleInputFieldsData={handleInputFieldsData} />

            </div>
    )
}

PermitAccount.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
    setPermitCount: PropTypes.object,

}

PermitAccount.defaulProps = {
    dispatch: noop,
    loader: false,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,
    setPermitCount: noop,

}

function mapStateToProps({ permitListReducer, PartnerReducer }) {
    return {
        loader: permitListReducer?.loader,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
    }
}
export default connect(mapStateToProps)(PermitAccount)